module.exports = __webpack_public_path__ + "static/slide_1_1-9ea8bd5760559968c3c1b65a75be000d.svg";